module.exports = __webpack_public_path__ + "static/media/se_video_tutorial.cf3befc4.mp4";